import React from 'react';
import BlankSection from '../components/sections/BlankSection';
import ContactConfirmationSection from '../components/sections/ContactConfirmationSection';
// import sections

const ContactConfirmation = () => {
  return (
    <>
      <BlankSection />
      <ContactConfirmationSection />
    </>
  );
}

export default ContactConfirmation;